import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { alloted_unalloted_list_loading : true, alloted_unalloted_list: '', alloted_unalloted_list_error: false};

export function allotUnallotBatch(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ALLOTED_UNALLOTED_DETAILS:
        return {
            alloted_unalloted_list_loading: true,
            alloted_unalloted_list: '',
            alloted_unalloted_list_error: false
        };
      case organisationConstants.RECIEVE_ALLOTED_UNALLOTED_DETAILS:
        return {
            alloted_unalloted_list_loading: false,
            alloted_unalloted_list: action.alloted_unalloted_list,
            alloted_unalloted_list_error: false
        };
      case organisationConstants.ERROR_ALLOTED_UNALLOTED_DETAILS:
        return { 
            alloted_unalloted_list_loading: false,
            alloted_unalloted_list: '',
            alloted_unalloted_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/allotUnallotBatchOrg.reducers.js